import { kea } from 'kea'
import PropTypes from 'prop-types'

export default kea({
  initScene: {
    scene: 'homepage',

    transform: payload => ({
      latestCourses: payload.latestCourses,
      covers: payload.covers,
      coverPhoto: payload.coverPhoto,
      coverPhotoData: payload.coverPhotoData,
      popularCities: payload.popularCities,
      popularCategories: payload.popularCategories,
      categorySuggestions: payload.categorySuggestions,
      reviews: payload.reviews,
      reviewsTitle: payload.reviewsTitle,
      categoryLinks: payload.categoryLinks,
      countrySlug: payload.countrySlug,
      helmet: payload.helmet,
      startPage: payload.startPage,
      popularActivities: payload.popularActivities,
      popularActivitiesTitle: payload.popularActivitiesTitle,
      howItWorksLink: payload.howItWorksLink
    })
  },

  path: () => ['scenes', 'homepage', 'index'],

  actions: () => ({
    showHow: true,
    hideHow: true,
    toggleSmallScreen: true,
    toggleMediumScreen: true,
    toggleLargeScreen: true,
    setIsMounted: true
  }),

  reducers: ({ actions }) => ({
    howIsOpen: [
      false,
      PropTypes.bool,
      {
        [actions.showHow]: () => true,
        [actions.hideHow]: () => false
      }
    ],
    smallScreen: [
      false,
      PropTypes.bool,
      {
        [actions.toggleSmallScreen]: state => !state
      }
    ],
    mediumScreen: [
      false,
      PropTypes.bool,
      {
        [actions.toggleMediumScreen]: state => !state
      }
    ],
    largeScreen: [
      false,
      PropTypes.bool,
      {
        [actions.toggleLargeScreen]: state => !state
      }
    ],
    latestCourses: [[], PropTypes.array, {}],
    covers: [[], PropTypes.array, {}],
    coverPhoto: [null, PropTypes.string, {}],
    coverPhotoData: [null, PropTypes.string, {}],
    popularCities: [[], PropTypes.array, {}],
    popularCategories: [[], PropTypes.array, {}],
    categorySuggestions: [[], PropTypes.array, {}],
    reviews: [[], PropTypes.array, {}],
    reviewsTitle: [null, PropTypes.string, {}],
    categoryLinks: [[], PropTypes.array, {}],
    countrySlug: [null, PropTypes.string, {}],
    helmet: [{}, PropTypes.object, {}],
    startPage: [{}, PropTypes.object, {}],
    popularActivities: [[], PropTypes.array, {}],
    popularActivitiesTitle: [null, PropTypes.string, {}],
    howItWorksLink: [null, PropTypes.string, {}],
    isMounted: [
      false,
      PropTypes.bool,
      {
        [actions.setIsMounted]: () => true
      }
    ]
  })
})
